(() => {
  const userActivityEvents = [
    "mousedown",
    "mousemove",
    "keydown",
    "scroll",
    "touchstart",
    "keypress",
    "touchmove",
  ];
  const SCRIPTS_LOADED_FLAG = "third-party-scripts-loaded";

  const interceptedHeadScriptElements = [];
  const originalHeadAppendChild = document.head.appendChild.bind(
    document.head,
  );
  const originalHeadInsertBefore = document.head.insertBefore.bind(
    document.head,
  );

  function interceptHeadAppendChild(node) {
    if (node.tagName === "SCRIPT") {
      interceptedHeadScriptElements.push(node);
      return node;
    }

    return originalHeadAppendChild(node);
  }

  function interceptHeadInsertBefore(node, referenceNode) {
    if (node.tagName === "SCRIPT") {
      interceptedHeadScriptElements.push(node);
      return node;
    }

    return originalHeadInsertBefore(node, referenceNode);
  }

  document.head.appendChild = interceptHeadAppendChild;
  document.head.insertBefore = interceptHeadInsertBefore;

  function restoreHeadAppendMethods() {
    document.head.appendChild = originalHeadAppendChild;
    document.head.insertBefore = originalHeadInsertBefore;
  }

  function waitForScriptToSettle(scriptElement, appendScript) {
    return new Promise((resolve) => {
      const timeoutId = setTimeout(resolve, 2000);

      const complete = () => {
        clearTimeout(timeoutId);
        resolve();
      };
      scriptElement.addEventListener("load", complete, { once: true });
      scriptElement.addEventListener("error", complete, { once: true });

      appendScript();
    });
  }

  async function onUserActivity() {
    for (const event of userActivityEvents) {
      window.removeEventListener(event, onUserActivity);
    }

    restoreHeadAppendMethods();

    const scriptTagsForLoad = Array.from(
      document.querySelectorAll("script[data-lazy-src]"),
    );

    const scriptsLoad = scriptTagsForLoad.map((scriptTag) =>
      waitForScriptToSettle(scriptTag, () => {
        scriptTag.src = scriptTag.dataset.lazySrc;
      }),
    );

    const interceptedScriptsLoad = interceptedHeadScriptElements.map(
      (scriptElement) =>
        waitForScriptToSettle(scriptElement, () => {
          originalHeadAppendChild(scriptElement);
        }),
    );
    interceptedHeadScriptElements.length = 0;

    window.dispatchEvent(new CustomEvent("load-head-scripts"));

    await Promise.all([...scriptsLoad, ...interceptedScriptsLoad]);

    localStorage.setItem(SCRIPTS_LOADED_FLAG, "true");

    window.dispatchEvent(new CustomEvent("third-party-scripts-loaded"));

    document.documentElement.classList.add("third-party-scripts-loaded");
  }

  function startListenUserActivity() {
    for (const event of userActivityEvents) {
      window.addEventListener(event, onUserActivity);
    }
  }

  window.addEventListener("load", () => {
    if (localStorage.getItem(SCRIPTS_LOADED_FLAG)) {
      onUserActivity();
    } else {
      startListenUserActivity();
    }
  });
})();